export default __webpack_public_path__ + "static/media/premium-thumbnail-hoopla.cf9d4443.svg";